import { render, staticRenderFns } from "./CustomerProductSelect.vue?vue&type=template&id=2ff16028&scoped=true"
import script from "./CustomerProductSelect.vue?vue&type=script&lang=js"
export * from "./CustomerProductSelect.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/customer-product-select.css?vue&type=style&index=0&id=2ff16028&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff16028",
  null
  
)

export default component.exports